// extracted by mini-css-extract-plugin
export var copyrightContainer = "Footer-module--copyrightContainer--+bBw0";
export var divider = "Footer-module--divider--lekJ1";
export var footer = "Footer-module--footer--jcvAa";
export var footerContainer = "Footer-module--footerContainer--iBiMa";
export var logoContainer = "Footer-module--logoContainer--f2ZOv";
export var moscaLink = "Footer-module--moscaLink--tYR5R";
export var span = "Footer-module--span--7IUSV";